import React from 'react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="w-full bg-court-950 py-20 text-white" aria-labelledby="testimonials-title" data-id="element-237" data-mp="3kpuirmacsxk5">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-238" data-mp="3fz5s296i04m2">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between" data-id="element-239" data-mp="3fxktm8h2c1ix">
          <h2 id="testimonials-title" className="font-display text-3xl font-black tracking-tight sm:text-4xl" data-id="element-240" data-mp="3b0azifiqb1or">
            What coaches are saying
          </h2>
          <p className="text-sm text-court-600" data-id="element-241" data-mp="31yl6j5977uov">
            <span className="tracking-[0.1em] text-ball" data-id="element-242" data-mp="2x09watezri64">⭐⭐⭐⭐⭐</span> 4.9/5 · 500+ coaches
            worldwide
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-243" data-mp="2s39qmjm20hfj">
          {testimonials.map(testimonial => <li key={testimonial.name} className="h-full" data-id="element-244" data-mp="v72ijof118mc">
              <figure className="flex h-full flex-col rounded-2xl border border-court-800 bg-court-900 p-7" data-id="element-245" data-mp="qbn6n20kxmsk">
                <div className="flex items-center gap-3" data-id="element-246" data-mp="h4dcylqnjo46">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ball font-display text-sm font-extrabold text-court-950" aria-hidden="true" data-id="element-247" data-mp="m5kl4lwpipbd">
                    {testimonial.initials}
                  </span>
                  <span className="text-sm tracking-[0.1em] text-ball" aria-label="5 out of 5 stars" data-id="element-248" data-mp="zvweeo512u43">
                    ⭐⭐⭐⭐⭐
                  </span>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-white" data-id="element-249" data-mp="14xdcyd01i4hi">
                  “{testimonial.quote}”
                </blockquote>
                <figcaption className="mt-auto pt-6 text-xs text-court-600" data-id="element-250" data-mp="v4o65vffpesi">
                  <span className="font-semibold text-white" data-id="element-251" data-mp="1ius6ntxbsyfa">{testimonial.name}</span> ·{' '}
                  {testimonial.role} · {testimonial.location}
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}